import { Document as ProDocument } from "@syadem/kairos-pro-js";
import { Document as TeamDocument } from "@syadem/kairos-team-js";
import { AppStore } from "../../store";
import { Service } from "../service";
import { ActionResult } from "../../actionResult";
import { ProDocumentFileApiInterface } from "../../network/apis/proDocumentFileApi";
import { TeamDocumentFileApiInterface } from "../../network/apis/teamDocumentFileApi";

interface Payload {
  organizationId: string | null;
  teamId: string | null;
  healthRecordId: string;
  documentId: string;
  attachments: File[];
  onProgressUpdate?: (fileIndex: number, progress: number) => void;
}

export class AttachDocumentFilesService implements Service<Payload, ProDocument | TeamDocument> {
  constructor(
    private readonly proDocumentFileApi: ProDocumentFileApiInterface,
    private readonly teamDocumentFileApi: TeamDocumentFileApiInterface,
    private readonly store: AppStore,
  ) {}

  async call({
    healthRecordId,
    organizationId,
    teamId,
    documentId,
    attachments,
    onProgressUpdate,
  }: Payload): Promise<ActionResult<ProDocument | TeamDocument>> {
    let apiDocument: ProDocument | TeamDocument | undefined;

    for (let i = 0; i < attachments.length; i++) {
      const file = attachments[i];
      if (organizationId && teamId) {
        apiDocument = await this.teamDocumentFileApi.attachFiles({
          organizationId,
          teamId,
          healthRecordId,
          documentId: documentId,
          attachments: [file],
          onProgressUpdate: (progress) => onProgressUpdate?.(i, progress),
        });
      } else {
        apiDocument = await this.proDocumentFileApi.attachFiles(healthRecordId, documentId, [file], (progress) =>
          onProgressUpdate?.(i, progress),
        );
      }
    }

    if (!apiDocument) {
      return {
        type: "error",
      };
    }

    this.updateDocumentInStore(healthRecordId, apiDocument);

    return {
      type: "success",
      value: apiDocument,
    };
  }

  private updateDocumentInStore(healthRecordId: string, document: ProDocument | TeamDocument) {
    this.store.setState((state) => {
      if (state.healthRecords && state.healthRecords[healthRecordId]) {
        return {
          ...state,
          healthRecords: {
            ...state.healthRecords,
            [healthRecordId]: {
              ...state.healthRecords[healthRecordId],
              documents: state.healthRecords[healthRecordId].documents.map((doc) => {
                if (doc.id === document.id) {
                  return document;
                }
                return doc;
              }),
            },
          },
        };
      }
      return state;
    });
  }
}
